import React, { FC } from 'react';
import useStyles from '../styles';
import { Service } from '../../types';

export type LinkWrapperProps = {
    item: Service;
    children?: JSX.Element;
    onClick?: (...args: unknown[]) => void;
    mode: 'dark' | 'light';
    RouterLink?: React.ElementType;
};

const LinkWrapper: FC<LinkWrapperProps> = ({ item, children, onClick, mode, RouterLink }) => {
    const classes = useStyles({ mode });

    return RouterLink && !item.external ? (
        <RouterLink to={item.url} onClick={onClick} className={classes.menuLink} key={item.name}>
            {children}
        </RouterLink>
    ) : (
        <a href={item.url} target="_blank" className={classes.menuLink} rel="noreferrer">
            {children}
        </a>
    );
};

export default LinkWrapper;
